import { styled } from '@mui/material/styles';
import { AppBar, Toolbar } from '@mui/material';

export const StyledBar = styled(AppBar)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  background: '#fff',
  boxShadow: '0px 2px 4px rgba(51, 70, 129, 0.1), inset 0px -1px 0px #E8ECEF',
  padding: 0
}));

export const Logo = styled('div')({
  flex: '0 0 auto',
  marginRight: '40px',
  cursor: 'pointer',

  '& img': {
    display: 'block'
  }
});

export const Header = styled(Toolbar)({
  padding: '10px 15px',
  minHeight: 80
});
